module.exports = __webpack_public_path__ + "media/images/front/pc/default/noimage_s664x430-e8d2c763a4c03136c39fa12e2b9ea4d6.png";